"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

interface QuickLink {
  label: string;
  href: string;
  description?: string;
}

interface QuickLinksProps {
  links: QuickLink[];
}

export function QuickLinks({ links }: QuickLinksProps) {
  const pathname = usePathname();

  return (
    <div className="flex flex-wrap gap-2">
      {links.map((link) => {
        const isActive = pathname === link.href;
        return (
          <Link
            key={link.href}
            href={link.href}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors min-h-[44px]",
              isActive
                ? "bg-white text-black"
                : "bg-white/5 text-text-muted hover:bg-white/10 hover:text-white border border-white/10",
            )}
          >
            {link.label}
          </Link>
        );
      })}
    </div>
  );
}
